module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/conditional-styles/conditional-styles.component.css
// module id = ./src/app/examples/conditional-styles/conditional-styles.component.css
// module chunks = main